const STAGES = [
  { key: 'all', label: 'All' },
  { key: 'ai_suggested', label: 'AI Suggested' },
  { key: 'approved', label: 'Approved' },
  { key: 'nda_sent', label: 'NDA Sent' },
  { key: 'signed', label: 'Signed' },
  { key: 'countersigned', label: 'Countersigned' },
  { key: 'slot_booked', label: 'Slot Booked' },
  { key: 'completed', label: 'Completed' },
  { key: 'rejected', label: 'Rejected' },
];

export default function LifecycleFilterPills({ activeFilter, onFilterChange, counts }) {
  return (
    <div style={{ display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 4 }}>
      {STAGES.map(s => {
        const isActive = activeFilter === s.key;
        const count = s.key === 'all'
          ? Object.values(counts || {}).reduce((a, b) => a + b, 0)
          : (counts?.[s.key] || 0);
        return (
          <button key={s.key} onClick={() => onFilterChange(s.key)} style={{
            padding: '8px 16px', borderRadius: 9999,
            border: isActive ? '1px solid #4F46E5' : '1px solid transparent',
            background: isActive ? '#EEF2FF' : '#F1F5F9',
            color: isActive ? '#4F46E5' : '#64748B',
            fontSize: 11, fontWeight: 600, fontFamily: 'Poppins, sans-serif',
            cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0
          }}>
            {s.label} ({count})
          </button>
        );
      })}
    </div>
  );
}
